module.exports = "/assets/packs/images/b9c2c234f560fd59199d3cfcb3ec7f6a.png";